import { Injectable } from '@angular/core';
import { BaseApiService } from './base-api.service';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';
import { VerifyIdModel, VerifySessionModel, VerifyWeakResponse } from '../../models/login.model';
import { VERIFY_ID, VERIFY_SESSION, VERIFY_WEAK } from '../../app.consts';
import { AuthService } from '../../services/auth.service';

@Injectable()
export class LoginApiService extends BaseApiService {
  constructor(private http: HttpClient, protected auth: AuthService) {
    super(auth);
  }

  verifyId(personalNumber: string): Observable<VerifyIdModel> {
    return this.http.post<VerifyIdModel>(`${this.apiUrl}${VERIFY_ID}`, {
      personalNumber,
    });
  }

  verifySession(sessionId: string): Observable<VerifySessionModel> {
    return this.http.post<VerifySessionModel>(
      `${this.apiUrl}${VERIFY_SESSION}`,
      { sessionId }
    );
  }

  verifyWeak(leadId: string, ssn: string): Observable<VerifyWeakResponse> {
    return this.http.post<VerifyWeakResponse>(
      `${this.apiUrl}${VERIFY_WEAK}`,
      { leadId, ssn }
    );
  }
}
